module.exports = __webpack_public_path__ + "static/tattoo3-093895e8c16ce82fd7cba2be891bd957.jpg";